<div class="ni__dropdown-wrapper relative" appClickOutside (clickOutSide)="closeDropdown()">
  <button type="button"
          class="secondary-dropdown-btn"
          [ngClass]="[!searchFacetValueNode.hasSelectedChildren ? 'not-selected-children' : '', isOpen ? 'open' : '']"
          (click)="toggleDropdown()">
    <span>{{ searchFacetValueNode.data.displayString }}</span>
    <svg-icon [key]="isOpen === true ? 'arrow-up' : 'arrow-down'" width="24px" height="24px"></svg-icon>
  </button>

  <ul class="ni__dropdown" aria-labelledby="search-dropdown" *ngIf="isOpen">
    <li class="ni__dropdown-item" *ngFor="let facet of searchFacetValueNode.children"
        (click)="narrowByFacet(facet.data)">
      <span [title]="facet.data.displayString">
        {{ facet.data.displayString }}
        <ng-container *ngIf="facet.data.count && facet.data.count > 0">
          ({{ facet.data.count <= 50 ? facet.data.count : "50+" }})
        </ng-container>
      </span>
    </li>
  </ul>
</div>
